import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center px-6 overflow-hidden" data-id="element-36">
      {/* Subtle animated radial gradient glow */}
      <motion.div className="absolute inset-0 z-0 flex items-center justify-center opacity-20 pointer-events-none" animate={{
      scale: [1, 1.05, 1],
      opacity: [0.05, 0.15, 0.05]
    }} transition={{
      duration: 10,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-37">
        <div className="w-[800px] h-[800px] rounded-full bg-brand-gold blur-[150px]" data-id="element-38" />
      </motion.div>

      <div className="z-10 flex flex-col items-center text-center w-full max-w-4xl mt-12" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.0,
        ease: 'easeOut'
      }} className="mb-20 flex flex-col items-center" data-id="element-40">
          <h1 className="font-heading text-5xl md:text-7xl tracking-ultra uppercase text-brand-gold font-light mb-6 ml-4" data-id="element-41">
            Pollock
          </h1>
          <h2 className="font-heading text-2xl md:text-3xl tracking-widest uppercase text-brand-gold font-light ml-2" data-id="element-42">
            Ventures
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col items-center" data-id="element-43">
          <p className="font-serif text-3xl md:text-5xl text-brand-offWhite mb-10 font-light" data-id="element-44">
            Investing in what's next.
          </p>

          <p className="font-sans text-sm md:text-base text-brand-warmGrey max-w-lg font-light leading-relaxed mb-16" data-id="element-45">
            Pollock Ventures invests in media, emerging technology, and
            high-conviction opportunities.
          </p>

          <motion.div className="w-px h-32 bg-gradient-to-b from-brand-gold/60 to-transparent" initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 128,
          opacity: 1
        }} transition={{
          duration: 1.0,
          delay: 1.0,
          ease: 'easeInOut'
        }} data-id="element-46" />
        </motion.div>
      </div>
    </section>;
}